module.exports = __webpack_public_path__ + "img/0-135.69a7bb11.jpg";